import { downloadFile } from 'api/utils/downloadFile';

import { registerResponseInterceptor } from '../api';

registerResponseInterceptor((response) => {
  const isJSON =
    response?.headers?.['content-type'] === 'application/json; charset=utf-8';

  const isBase64Download =
    isJSON &&
    response?.data?.contentType &&
    response?.data?.data &&
    response?.data?.fileName;

  if (isBase64Download) {
    // eslint-disable-next-line no-console
    console.debug('[API] Download base64 file');
    const href = `data:${response?.data?.contentType};charset=utf-8;base64,${response?.data?.data}`;
    const fileName = response?.data?.fileName;
    downloadFile(href, fileName);
  }

  return response;
}, 'Download base64 handler');
